import { Expand, LabeledGroup } from '@magicdoorinc/ui';
import { createMemo, Show } from 'solid-js';
import { Dynamic } from 'solid-js/web';
import InputSwitch from '~/components/common/Inputs/InputSwitch';
import type { LabeledGroupProps } from '@magicdoorinc/ui';
import type { Component } from 'solid-js';

export const Switcher = (
  props: {
    icon?: Component;
    value?: boolean;
    onInput?: (value: boolean) => void;
    expandWhen?: (value: boolean) => boolean;
    content?: Component<{ isExpanded?: boolean }>;
    disabled?: boolean;
  } & LabeledGroupProps
) => {
  const isExpanded = createMemo(() => props.expandWhen?.(props.value ?? false));

  return (
    <LabeledGroup error={props.error}>
      <Expand open={isExpanded()} class="border-inputbox-border flex flex-col rounded-md border p-4">
        <div class="flex items-center justify-between gap-2">
          <div class="flex items-center gap-2">
            <Show when={props.icon}>
              <Dynamic component={props.icon} />
            </Show>
            <span class="text-sm font-medium text-text-02">{props.labelJSX}</span>
          </div>
          <InputSwitch checked={props.value} onChange={(v) => props.onInput?.(v)} disabled={props.disabled} />
        </div>
        <Show when={props.content}>
          <Expand.Content>
            <div class="m-1 mt-4">
              <Dynamic component={props.content} isExpanded={isExpanded()} />
            </div>
          </Expand.Content>
        </Show>
      </Expand>
    </LabeledGroup>
  );
};
